import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initTheme } from '@workinance/shared/stores/theme.store';

import './index.css';

import App from './App.tsx';

// Put the saved theme on the page before the first paint.
initTheme();

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
